import { createSlice } from "@reduxjs/toolkit";
import { getCanceledOrders } from "./CanceledOrdersAction";

const initialState = {
  loading: false,
  error: null,
  success: false,
  orders: [],
  latestRequestId: null,
};

const canceledOrdersSlice = createSlice({
  name: "canceledOrders",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCanceledOrders.pending, (state, action) => {
        state.loading = true;
        state.latestRequestId = action.meta.requestId;
      })
      .addCase(getCanceledOrders.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.loading = false;
        state.orders = action.payload;
      })
      .addCase(getCanceledOrders.rejected, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export default canceledOrdersSlice.reducer;
